import { APP_PREFIX_PATH } from 'constants/route.constant'
import {
    NAV_ITEM_TYPE_TITLE,
    NAV_ITEM_TYPE_COLLAPSE,
    NAV_ITEM_TYPE_ITEM,
} from 'constants/navigation.constant'
import { ADMIN, SUPPORT } from 'constants/roles.constant'
import features from '../features'

const appsNavigationConfig = [
    {
        key: '',
        path: '',
        title: 'APPS',
        translateKey: 'nav.apps',
        icon: 'apps',
        type: NAV_ITEM_TYPE_TITLE,
        authority: [ADMIN], // Only admins see the main APPS section
        subMenu: [
            {
                key: 'apps.sales',
                path: '',
                title: 'Sales',
                translateKey: 'nav.appsSales.sales',
                icon: 'sales',
                type: NAV_ITEM_TYPE_COLLAPSE,
                authority: [ADMIN], // Only admins can see Sales section
                subMenu: [
                    {
                        key: 'appsSales.dashboard',
                        path: `${APP_PREFIX_PATH}/sales/dashboard`,
                        title: 'Dashboard',
                        translateKey: 'nav.appsSales.dashboard',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsSales.analytics',
                        path: `${APP_PREFIX_PATH}/analytics`,
                        title: 'Analytics',
                        translateKey: 'nav.appsSales.analytics',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsSales.liveVisitors',
                        path: `${APP_PREFIX_PATH}/analytics/live-visitors`,
                        title: 'Live Visitors',
                        translateKey: 'nav.appsSales.liveVisitors',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsSales.productInterest',
                        path: `${APP_PREFIX_PATH}/analytics/product-interest`,
                        title: 'Product Interest',
                        translateKey: 'nav.appsSales.productInterest',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsSales.behavior',
                        path: `${APP_PREFIX_PATH}/analytics/behavior`,
                        title: 'Behavior',
                        translateKey: 'nav.appsSales.behavior',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsSales.visitorChat',
                        path: `${APP_PREFIX_PATH}/analytics/visitor-chat`,
                        title: 'Visitor Chat',
                        translateKey: 'nav.appsSales.visitorChat',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsSales.reservations',
                        path: `${APP_PREFIX_PATH}/sales/reservations`,
                        title: 'Reservations',
                        translateKey: 'nav.appsSales.reservations',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsSales.orderList',
                        path: `${APP_PREFIX_PATH}/sales/order-list`,
                        title: 'Orders',
                        translateKey: 'nav.appsSales.orderList',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsSales.shippingManagement',
                        path: `${APP_PREFIX_PATH}/sales/shipping`,
                        title: 'Shipping',
                        translateKey: 'nav.appsSales.shippingManagement',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsSales.personalShopping',
                        path: `${APP_PREFIX_PATH}/sales/personal-shopping`,
                        title: 'Personal Shopping',
                        translateKey: 'nav.appsSales.personalShopping',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsSales.paymentLinks',
                        path: `${APP_PREFIX_PATH}/sales/payment-links`,
                        title: 'Payment Links',
                        translateKey: 'nav.appsSales.paymentLinks',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsSales.exchange',
                        path: `${APP_PREFIX_PATH}/sales/exchange`,
                        title: 'Exchange',
                        translateKey: 'nav.appsSales.exchange',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsSales.offers',
                        path: `${APP_PREFIX_PATH}/sales/offers`,
                        title: 'Offers',
                        translateKey: 'nav.appsSales.offers',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsSales.disputes',
                        path: `${APP_PREFIX_PATH}/sales/disputes`,
                        title: 'Disputes',
                        translateKey: 'nav.appsSales.disputes',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsSales.reviews',
                        path: `${APP_PREFIX_PATH}/sales/reviews`,
                        title: 'Reviews',
                        translateKey: 'nav.appsSales.reviews',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsSales.pushCampaigns',
                        path: `${APP_PREFIX_PATH}/sales/push-campaigns`,
                        title: 'Push Campaigns',
                        translateKey: 'nav.appsSales.pushCampaigns',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsSales.referrals',
                        path: `${APP_PREFIX_PATH}/sales/referrals`,
                        title: 'Referrals',
                        translateKey: 'nav.appsSales.referrals',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                ],
            },
            {
                key: 'apps.users',
                path: '',
                title: 'Users',
                translateKey: 'nav.appsUsers.users',
                icon: 'crm',
                type: NAV_ITEM_TYPE_COLLAPSE,
                authority: [ADMIN], // Only admins can see the Users section
                subMenu: [
                    {
                        key: 'appsUsers.usersList',
                        path: `${APP_PREFIX_PATH}/sales/users-list`,
                        title: 'Clients List',
                        translateKey: 'nav.appsUsers.usersList',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsUsers.supportUsers',
                        path: `${APP_PREFIX_PATH}/sales/support-users`,
                        title: 'Staff & Admins',
                        translateKey: 'nav.appsUsers.supportUsers',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsSales.bankDetails',
                        path: `${APP_PREFIX_PATH}/sales/bank-details`,
                        title: 'Bank Details',
                        translateKey: 'nav.appsSales.bankDetails',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    ...(features.ADMIN_APPROVAL ? [{
                        key: 'appsUsers.pendingApprovals',
                        path: `${APP_PREFIX_PATH}/sales/pending-users`,
                        title: 'Pending Approvals',
                        translateKey: 'nav.appsUsers.pendingApprovals',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    }] : []),
                    {
                        key: 'appsUsers.sellerApplications',
                        path: `${APP_PREFIX_PATH}/users/seller-applications`,
                        title: 'Seller Applications',
                        translateKey: 'nav.appsUsers.sellerApplications',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsUsers.sellers',
                        path: `${APP_PREFIX_PATH}/users/sellers`,
                        title: 'Approved Sellers',
                        translateKey: 'nav.appsUsers.sellers',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                ],
            },
            {
                key: 'apps.section.catalog',
                path: '',
                title: 'Catalog',
                translateKey: 'nav.appsSection.catalog',
                icon: '',
                type: NAV_ITEM_TYPE_TITLE,
                authority: [ADMIN],
                subMenu: [],
            },
            {
                key: 'apps.categories',
                path: '',
                title: 'Categories',
                translateKey: 'nav.appsCategories.categories',
                icon: 'category',
                type: NAV_ITEM_TYPE_COLLAPSE,
                authority: [ADMIN], // Only admins can see Categories
                subMenu: [
                    {
                        key: 'appsCategories.categoryList',
                        path: `${APP_PREFIX_PATH}/sales/category-list`,
                        title: 'Category Management',
                        translateKey: 'nav.appsCategories.categoryList',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                ],
            },
            {
                key: 'apps.brands',
                path: '',
                title: 'Brands',
                translateKey: 'nav.appsBrands.brands',
                icon: 'shoppingBag',
                type: NAV_ITEM_TYPE_COLLAPSE,
                authority: [ADMIN], // Only admins can see Brands
                subMenu: [
                    {
                        key: 'appsBrands.brandList',
                        path: `${APP_PREFIX_PATH}/sales/brand-list`,
                        title: 'Brand Management',
                        translateKey: 'nav.appsBrands.brandList',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                ],
            },
            {
                key: 'apps.sellingTypes',
                path: '',
                title: 'Selling Types',
                translateKey: 'nav.appsSellingTypes.sellingTypes',
                icon: 'category',
                type: NAV_ITEM_TYPE_COLLAPSE,
                authority: [ADMIN], // Only admins can see Selling Types
                subMenu: [
                    {
                        key: 'appsSellingTypes.sellingTypeList',
                        path: `${APP_PREFIX_PATH}/sales/selling-type-list`,
                        title: 'Selling Type Management',
                        translateKey: 'nav.appsSellingTypes.sellingTypeList',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                ],
            },
            {
                key: 'apps.products',
                path: '',
                title: 'Products',
                translateKey: 'nav.appsProducts.products',
                icon: 'shoppingBag',
                type: NAV_ITEM_TYPE_COLLAPSE,
                authority: [ADMIN], // Only admins can see Products
                subMenu: [
                    {
                        key: 'appsProducts.productList',
                        path: `${APP_PREFIX_PATH}/sales/product-list`,
                        title: 'Listings',
                        translateKey: 'nav.appsProducts.productList',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsProducts.listingNew',
                        path: `${APP_PREFIX_PATH}/catalog/listing-new`,
                        title: 'Add Listing',
                        translateKey: 'nav.appsProducts.listingNew',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsProducts.productNew',
                        path: `${APP_PREFIX_PATH}/catalog/product-new`,
                        title: 'Add Product',
                        translateKey: 'nav.appsProducts.productNew',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsProducts.pendingReview',
                        path: `${APP_PREFIX_PATH}/sales/pending-products`,
                        title: 'Pending Reviews',
                        translateKey: 'nav.appsProducts.pendingReview',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                ],
            },
            {
                key: 'apps.section.merchandising',
                path: '',
                title: 'Merchandising',
                translateKey: 'nav.appsSection.merchandising',
                icon: '',
                type: NAV_ITEM_TYPE_TITLE,
                authority: [ADMIN],
                subMenu: [],
            },
            {
                key: 'apps.banners',
                path: '',
                title: 'Banners',
                translateKey: 'nav.appsBanners.banners',
                icon: 'banners',
                type: NAV_ITEM_TYPE_COLLAPSE,
                authority: [ADMIN], // Only admins can see Banners
                subMenu: [
                    {
                        key: 'appsBanners.bannerList',
                        path: `${APP_PREFIX_PATH}/sales/banner-list`,
                        title: 'Banner List',
                        translateKey: 'nav.appsBanners.bannerList',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsBanners.bannerNew',
                        path: `${APP_PREFIX_PATH}/sales/banner-new`,
                        title: 'Add Banner',
                        translateKey: 'nav.appsBanners.bannerNew',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                ],
            },
            {
                key: 'apps.collections',
                path: '',
                title: 'Collections',
                translateKey: 'nav.appsCollections.collections',
                icon: 'collections',
                type: NAV_ITEM_TYPE_COLLAPSE,
                authority: [ADMIN],
                subMenu: [
                    {
                        key: 'appsCollections.collectionList',
                        path: `${APP_PREFIX_PATH}/sales/collection-list`,
                        title: 'Collection List',
                        translateKey: 'nav.appsCollections.collectionList',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsCollections.collectionNew',
                        path: `${APP_PREFIX_PATH}/sales/collection-new`,
                        title: 'Add Collection',
                        translateKey: 'nav.appsCollections.collectionNew',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                ],
            },
            {
                key: 'apps.seasonCollections',
                path: '',
                title: 'Season Drops',
                translateKey: 'nav.seasonCollections',
                icon: 'collections',
                type: NAV_ITEM_TYPE_COLLAPSE,
                authority: [ADMIN],
                subMenu: [
                    {
                        key: 'seasonCollections.list',
                        path: `${APP_PREFIX_PATH}/sales/season-collections`,
                        title: 'All Drops',
                        translateKey: 'nav.seasonCollections.list',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'seasonCollections.new',
                        path: `${APP_PREFIX_PATH}/sales/season-collections/new`,
                        title: 'Create Drop',
                        translateKey: 'nav.seasonCollections.new',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'seasonCollections.preorders',
                        path: `${APP_PREFIX_PATH}/sales/season-collections/preorders`,
                        title: 'Pre-Orders',
                        translateKey: 'nav.seasonCollections.preorders',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                ],
            },
            {
                key: 'apps.coupons',
                path: '',
                title: 'Coupons',
                translateKey: 'nav.appsCoupons.coupons',
                icon: 'shoppingBag',
                type: NAV_ITEM_TYPE_COLLAPSE,
                authority: [ADMIN],
                subMenu: [
                    {
                        key: 'appsCoupons.couponList',
                        path: `${APP_PREFIX_PATH}/sales/coupon-list`,
                        title: 'Coupon List',
                        translateKey: 'nav.appsCoupons.couponList',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsCoupons.couponNew',
                        path: `${APP_PREFIX_PATH}/sales/coupon-new`,
                        title: 'Add Coupon',
                        translateKey: 'nav.appsCoupons.couponNew',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                ],
            },
            {
                key: 'apps.faqs',
                path: '',
                title: 'FAQs',
                translateKey: 'nav.appsFaqs.faqs',
                icon: 'knowledgeBase',
                type: NAV_ITEM_TYPE_COLLAPSE,
                authority: [ADMIN], // Only admins can see FAQs
                subMenu: [
                    {
                        key: 'appsFaqs.faqsList',
                        path: `${APP_PREFIX_PATH}/sales/faqs-list`,
                        title: 'FAQs List',
                        translateKey: 'nav.appsFaqs.faqsList',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                ],
            },
            // {
            //     key: 'apps.languages',
            //     path: '',
            //     title: 'Languages',
            //     translateKey: 'nav.appsLanguages.languages',
            //     icon: 'language',
            //     type: NAV_ITEM_TYPE_COLLAPSE,
            //     authority: [ADMIN, USER],
            //     subMenu: [
            //         {
            //             key: 'appsLanguages.languageList',
            //             path: `${APP_PREFIX_PATH}/sales/language-list`,
            //             title: 'Language List',
            //             translateKey: 'nav.appsLanguages.languageList',
            //             icon: '',
            //             type: NAV_ITEM_TYPE_ITEM,
            //             authority: [ADMIN, SUPPORT],
            //             subMenu: [],
            //         },
            //     ],
            // },
            {
                key: 'apps.taxonomies',
                path: '',
                title: 'Taxonomies',
                translateKey: 'nav.appsTaxonomies.taxonomies',
                icon: 'category',
                type: NAV_ITEM_TYPE_COLLAPSE,
                authority: [ADMIN], // Only admins can see Taxonomies
                subMenu: [
                    {
                        key: 'appsTaxonomies.typesList',
                        path: `${APP_PREFIX_PATH}/sales/types-list`,
                        title: 'Types',
                        translateKey: 'nav.appsTaxonomies.typesList',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    }
                ],
            },
            {
                key: 'apps.section.operations',
                path: '',
                title: 'Operations',
                translateKey: 'nav.appsSection.operations',
                icon: '',
                type: NAV_ITEM_TYPE_TITLE,
                authority: [ADMIN],
                subMenu: [],
            },
            {
                key: 'apps.feeManagement',
                path: '',
                title: 'Fee Management',
                translateKey: 'nav.appsFeeManagement.feeManagement',
                icon: 'feeMoney',
                type: NAV_ITEM_TYPE_COLLAPSE,
                authority: [ADMIN], // Only admins can see Fee Management
                subMenu: [
                    {
                        key: 'appsFeeManagement.feeConfiguration',
                        path: `${APP_PREFIX_PATH}/fee-management/configuration`,
                        title: 'Fee Configuration',
                        translateKey: 'nav.appsFeeManagement.feeConfiguration',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsFeeManagement.currencyManagement',
                        path: `${APP_PREFIX_PATH}/fee-management/currency-management`,
                        title: 'Currency Management',
                        translateKey: 'nav.appsFeeManagement.currencyManagement',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                ],
            },
            {
                key: 'apps.reports',
                path: '',
                title: 'Reports',
                translateKey: 'nav.appsReports.reports',
                icon: 'reports',
                type: NAV_ITEM_TYPE_COLLAPSE,
                authority: [ADMIN],
                subMenu: [
                    {
                        key: 'appsReports.orderReports',
                        path: `${APP_PREFIX_PATH}/sales/reports/orders`,
                        title: 'Order Reports',
                        translateKey: 'nav.appsReports.orderReports',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsReports.transactionReports',
                        path: `${APP_PREFIX_PATH}/sales/reports/transactions`,
                        title: 'Transaction Reports',
                        translateKey: 'nav.appsReports.transactionReports',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsReports.payoutReports',
                        path: `${APP_PREFIX_PATH}/sales/reports/payouts`,
                        title: 'Payout Reports',
                        translateKey: 'nav.appsReports.payoutReports',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                ],
            },
            {
                key: 'apps.shipping',
                path: '',
                title: 'Shipping',
                translateKey: 'nav.appsShipping.shipping',
                icon: 'shipping',
                type: NAV_ITEM_TYPE_COLLAPSE,
                authority: [ADMIN],
                subMenu: [
                    {
                        key: 'appsShipping.shippingList',
                        path: `${APP_PREFIX_PATH}/shipping/list`,
                        title: 'Shipping Options',
                        translateKey: 'nav.appsShipping.shippingList',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsShipping.shippingNew',
                        path: `${APP_PREFIX_PATH}/shipping/new`,
                        title: 'Add Shipping Option',
                        translateKey: 'nav.appsShipping.shippingNew',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                    {
                        key: 'appsShipping.dhlRateCard',
                        path: `${APP_PREFIX_PATH}/shipping/dhl-rate-card`,
                        title: 'DHL Rate Card',
                        translateKey: 'nav.appsShipping.dhlRateCard',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                ],
            },
            {
                key: 'apps.notifications',
                path: '',
                title: 'Notifications',
                translateKey: 'nav.appsNotifications.notifications',
                icon: 'feedback',
                type: NAV_ITEM_TYPE_COLLAPSE,
                authority: [ADMIN],
                subMenu: [
                    {
                        key: 'appsNotifications.notificationsList',
                        path: `${APP_PREFIX_PATH}/sales/notifications`,
                        title: 'Notifications',
                        translateKey: 'nav.appsNotifications.notificationsList',
                        icon: '',
                        type: NAV_ITEM_TYPE_ITEM,
                        authority: [ADMIN],
                        subMenu: [],
                    },
                ],
            },
        ],
    },
    // Settings section - admin only
    {
        key: 'apps.settings',
        path: '',
        title: 'Settings',
        translateKey: 'nav.appsSettings.settings',
        icon: 'settings',
        type: NAV_ITEM_TYPE_COLLAPSE,
        authority: [ADMIN],
        subMenu: [
            {
                key: 'appsSettings.appConfig',
                path: `${APP_PREFIX_PATH}/settings/app-config`,
                title: 'App Config',
                translateKey: 'nav.appsSettings.appConfig',
                icon: '',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [ADMIN],
                subMenu: [],
            },
            {
                key: 'appsSettings.homepageConfig',
                path: `${APP_PREFIX_PATH}/settings/homepage`,
                title: 'Homepage Layout',
                translateKey: 'nav.appsSettings.homepageConfig',
                icon: '',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [ADMIN],
                subMenu: [],
            },
            {
                key: 'appsSettings.paymentPricing',
                path: `${APP_PREFIX_PATH}/settings/payment-pricing`,
                title: 'Payment Pricing',
                translateKey: 'nav.appsSettings.paymentPricing',
                icon: '',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [ADMIN],
                subMenu: [],
            },
        ],
    },
    // Chat Threads section - visible to both admin and support users
    {
        key: 'apps.chats',
        path: '',
        title: 'Chat Threads',
        translateKey: 'nav.appsChats.chats',
        icon: 'chat',
        type: NAV_ITEM_TYPE_COLLAPSE,
        authority: [ADMIN, SUPPORT],
        subMenu: [
            {
                key: 'appsChats.chatsList',
                path: `${APP_PREFIX_PATH}/sales/chats`,
                title: 'Chat Threads',
                translateKey: 'nav.appsChats.chatsList',
                icon: '',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [ADMIN, SUPPORT],
                subMenu: [],
            },
        ],
    },
    // Support section - visible to both admin and support users
    {
        key: 'apps.support',
        path: '',
        title: 'Support',
        translateKey: 'nav.appsSupport.support',
        icon: 'feedback',
        type: NAV_ITEM_TYPE_COLLAPSE,
        authority: [ADMIN, SUPPORT],
        subMenu: [
            {
                key: 'appsSupport.supportList',
                path: `${APP_PREFIX_PATH}/sales/support-list`,
                title: 'Support Tickets',
                translateKey: 'nav.appsSupport.supportList',
                icon: '',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [ADMIN, SUPPORT],
                subMenu: [],
            },
            {
                key: 'appsSupport.liveSupport',
                path: `${APP_PREFIX_PATH}/sales/live-support`,
                title: 'Live Support',
                translateKey: 'nav.appsSupport.liveSupport',
                icon: '',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [ADMIN, SUPPORT],
                subMenu: [],
            },
        ],
    },
]

export default appsNavigationConfig
